import $ from 'jquery';
import Cookies from 'js-cookie';
import modaal from 'modaal';
import validationRules from '../utils/validation';
import * as CONST from '../utils/constants';
import analytics from '../utils/analytics';

const lightboxId = $('.newsletter-modal-content').data('lightbox-id');
const expirationDays = $('.newsletter-modal-content').data('expiration-days');
const createCookie = $('.newsletter-modal-content').data('create-cookie');
const cookieSwitch = $('.newsletter-modal-content').data('cookie-switch');
const alternateText = Cookies.get('newsletterForm');

class Modal {
	constructor() {
		this.modalShown = Cookies.get(lightboxId);
		this.modal = null;
		//this.focusElement = null;
	}

	init() {
		this.bindEvents();	

		$(window).scroll((e) => {
			let ScrollTop = document.documentElement.scrollTop;
			let isFromNewsletter = this.getParameterValues('fromNewsletter');
			if ($('.hide-newsletter-modal').length > 0) {
				Cookies.set(lightboxId, 'shown', { expires: expirationDays, sameSite: 'strict' });
				this.modalShown = 'shown';
			} else if (isFromNewsletter) {
				Cookies.set(lightboxId, 'shown', { expires: expirationDays, sameSite: 'strict' });
				this.modalShown = 'shown';
			}
			else if (ScrollTop > 400) {
				if (this.modalShown === undefined && this.modal) {
					Cookies.set(lightboxId, 'shown', { expires: expirationDays, sameSite: 'strict' });
					this.modalShown = 'shown';
					//this.focusElement = $(':focus');
					this.modal.modaal('open');
				}
			}
			if ($('.modaal-wrapper.location-modal').length > 0 && $('.modaal-wrapper.newsletter-modal').length > 0) {
				$('.modaal-wrapper.newsletter-modal').hide();
				$('.modaal-wrapper.newsletter-modal').next('.modaal-overlay').hide();
				Cookies.remove(lightboxId, { expires: expirationDays, sameSite: 'strict' });
			}

			if (ScrollTop > 2400) {
				$('.back-to-top').removeClass('d-none');
			} else {
				$('.back-to-top').addClass('d-none');
			}
		});
		this.eventListAnalytics();
		window.modalController = this;

		if ($('#location-state-code').text() === '') {
			$('.header-info-location').trigger('click');
		}

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		let url = window.location.href;

		if ($('input[id*=_Source_Value]').length > 0) {
			const sSrc = $('input[id*=_Source_Value]').val();
			const paramsSrc = urlParams.get('s_src');
			if (url.includes('s_src')) {
				$('input[id*=_Source_Value]').val(paramsSrc);
			} else {
				$('input[id*=_Source_Value]').val(sSrc);
			}
		}

		if ($('input[id*=_Source_Value]').length > 0) {
			const sSubSrc = $('input[id*=_SubSource_Value]').val();
			const paramsSubSrc = urlParams.get('s_subsrc');
			if (url.includes('s_subsrc')) {
				$('input[id*=_SubSource_Value]').val(paramsSubSrc);
			} else {
				$('input[id*=_SubSource_Value]').val();
			}
		}
	}

	bindEvents() {
		$('.js-inline-modal').modaal();
		this.newCookieAddition();

		if (cookieSwitch && alternateText) {
			if ($('.newsletter-modal-alt-link').length) {
				if ($('.hide-newsletter-modal').length === 0) {
					this.modal = $('.newsletter-modal-alt-link').modaal({
						overlay_opacity: 0,
						background_scroll: true,
						custom_class: 'newsletter-modal',
					});
				}
			}
		} else if ($('.newsletter-modal-link').length) {
			if ($('.hide-newsletter-modal').length === 0) {
				this.modal = $('.newsletter-modal-link').modaal({
					overlay_opacity: 0,
					background_scroll: true,
					custom_class: 'newsletter-modal',
					//after_open: () => {
						//setTimeout(() => {
							//$('.newsletter-modal input[name="cons_email"]').focus();
						//}, 400);
					//},
					//after_close: () => {
						//setTimeout(() => {
							//$(this.focusElement).focus();
						//}, 400);
					//}
				});
			}
		}

		$('.js-helpline-modal').modaal({
			content_source: '.helpLineModal',
			custom_class: 'help-line-modal',
		});

		$('.js-location-modal').modaal({
			content_source: '.locationModal',
			custom_class: 'location-modal',

		});
		$('.js-language-modal').modaal({
			content_source: '.languageModal',
			custom_class: 'language-modal',

		});
		window.processLocationModal = this.locationModal;

		$('.back-to-top').click(() => {
			$('html, body').animate({
				scrollTop: 100
			}, 1000);
		});

		$('input#zip').blur(() => {
			let zip = $('#zip').val();
			if (zip.length > 0 && !validationRules.isValidUSZip(zip)) {
				$('#zipErrorMessage').text('Please enter a valid zip code');
				$('#zipErrorMessage').removeClass('d-none');
			} else {
				$('#zipErrorMessage').addClass('d-none');
			}
		});
	}

	locationModal() {
		let zip = $('#zip').val();
		let state = $('select#stateChosen').val();
		if (zip.length > 0 && validationRules.isValidUSZip(zip)) {
			$.get(`/api/states/zipcode/${zip}`, (data) => {
				if (!data) {
					$('#zipErrorMessage').removeClass('d-none');
					$('#zipErrorMessage').text('Unable to find your location based on this zipcode');
				} else {
					state = data;
					this.updateLocation(state);
				}
			});
		} else if (zip.length === 0) {
			this.updateLocation(state);
		}
	}

	updateLocation(state) {
		Cookies.set('StateCode', state, { sameSite: 'strict' });
		$('.header-info-location').html(`<span class="icon-location-marker"></span> ${state}`);
		$('.mobile-location-info').html(`${state}`);
		$('#zipErrorMessage').text('');
		this.updateLocalContent(state);
		this.updateLocalEvents(state);
		$('.js-location-modal').modaal('close');
	}

	languageModal() {
		this.updateLanguage();
	}

	updateLanguage() {
		$('.js-language-modal').modaal('close');
	}

	updateLocalContent(state) {
		$('.local-content').each((_, el) => {
			const guid = $(el).attr('data-content-type');
			if (guid !== '') {
				$.get(`/api/localcontent?typeGuid=${guid}&stateCode=${state}`, (data) => {
					if (data) {
						$(el).html(data);
					} else {
						$(el).html('');
					}
				});
			}
		});
	}

	getParameterValues(param) {
		let url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (let i = 0; i < url.length; i += 1) {
			let urlparam = url[i].split('=');
			if (urlparam[0] === param) {
				return urlparam[1];
			}
		}
		return null;
	}

	updateLocalEvents(state) {
		if ($('.local-events').length > 0) {
			const dateString = new Date().toISOString().slice(0, 10);
			$.get(`/api/events/upcoming?StartingAfter=${dateString}&StateCode=${state}`, (data) => {
				$('.local-events').each((_, el) => {
					if (data) {
						let template = $('#event-list-template').html();
						$(el).empty();
						window.EventList = data;
						data.forEach((ev, i) => {
							let newEvent = $(template);
							if (ev.IsRecurring) {
								//$(newEvent).find('.icon-calendar').hide();
								//$(newEvent).find('.icon-monitor').hide();
								//$(newEvent).find('.icon-recurring').show();
								if (!ev.IsVirtual || !ev.IsVirtualEvent) {
									if (ev.DateTBD) {
										$(newEvent).find('.card-event-range').html('<span class="start-date">TBD</span>');
									} else if (ev.EndDateDisplay === 'Jan 1, 0001') {
										$(newEvent).find('.card-event-range').html(`<span class="start-date">${ev.DateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									} else {
										$(newEvent).find('.card-event-range').html(`<span class="start-end-date">${ev.DateDisplay} - ${ev.EndDateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									}
									$(newEvent).find('.card-content-title-wrap div').hide();
								} else {
									if (ev.DateTBD) {
										$(newEvent).find('.card-event-range').html('<span class="start-date">TBD</span>');
									} else if (ev.EndDateDisplay === 'Jan 1, 0001') {
										$(newEvent).find('.card-event-range').html(`<span class="start-date">${ev.DateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									} else {
										$(newEvent).find('.card-event-range').html(`<span class="start-end-date">${ev.DateDisplay} - ${ev.EndDateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									}
									$(newEvent).find('.card-content-title-wrap div').hide();
								}
							} else if (ev.IsVirtual || ev.IsVirtualEvent) {
								//$(newEvent).find('.icon-calendar').hide();
								//$(newEvent).find('.icon-monitor').show();
								//$(newEvent).find('.icon-recurring').hide();
								$(newEvent).find('.icon-calendar').addClass('icon-monitor');
								if (!ev.IsRecurring) {
									if (ev.DateTBD) {
										$(newEvent).find('.card-event-range').html('<span class="start-date">TBD</span>');
									} else if (ev.EndDateDisplay === 'Jan 1, 0001') {
										$(newEvent).find('.card-event-range').html(`<span class="start-date">${ev.DateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									} else {
										$(newEvent).find('.card-event-range').html(`<span class="start-end-date">${ev.DateDisplay} - ${ev.EndDateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									}
									$(newEvent).find('.card-content-title-wrap div').hide();
								} else {
									if (ev.DateTBD) {
										$(newEvent).find('.card-event-range').html('<span class="start-date">TBD</span>');
									} else if (ev.EndDateDisplay === 'Jan 1, 0001') {
										$(newEvent).find('.card-event-range').html(`<span class="start-date">${ev.DateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									} else {
										$(newEvent).find('.card-event-range').html(`<span class="start-end-date">${ev.DateDisplay} - ${ev.EndDateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
									}
									$(newEvent).find('.card-content-title-wrap div').hide();
								}
							} else {
								let startDate = new Date(ev.StartDate);
								let endDate = new Date(ev.EndDate);
								//$(newEvent).find('.icon-calendar').show();
								//$(newEvent).find('.icon-monitor').hide();
								//$(newEvent).find('.icon-recurring').hide();
								if (ev.DateTBD) {
									$(newEvent).find('.card-event-range').html('<span class="start-date">TBD</span>');
								} else if (ev.EndDateDisplay === 'Jan 1, 0001') {
									$(newEvent).find('.card-event-range').html(`<span class="start-date">${ev.DateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
								} else {
									$(newEvent).find('.card-event-range').html(`<span class="start-end-date">${ev.DateDisplay} - ${ev.EndDateDisplay}</span> ${ev.DateTextDisplay !== '' ? `<span class="event-pipe">|</span><span class="recurring-date-text-display">${ev.DateTextDisplay}</span>` : ''}`);
								}
							}

							$(newEvent).find('a').attr('href', ev.Url).attr('data-eventid', ev.Id)
							.attr('data-title', ev.Title)
							.attr('data-date', ev.StartDate)
							.attr('data-enddate', ev.EndDate)
							.attr('data-datedisplay', ev.DateDisplay)
							.attr('data-enddatedisplay', ev.EndDateDisplay)
							.attr('data-name', ev.EventName)
							.attr('data-city', ev.City)
							.attr('data-state', ev.State)
							.attr('data-type', ev.EventType)
							.attr('data-category', ev.Categories)
							.attr('data-datetbd', ev.DateTBD)
							.attr('data-venue', ev.Venue)
							.attr('data-featured', ev.IsFeatured);
							if (!ev.IsFeatured) {
								$(newEvent).find('.card-event-featured').hide();
							}
							if (ev.City && ev.State) {
								$(newEvent).find('.card-event-city-state').text(`${ev.City}, ${ev.State}`);
							} else if (!ev.City && ev.State) {
								$(newEvent).find('.card-event-city-state').text(ev.State);
							} else if (ev.City && !ev.State) {
								$(newEvent).find('.card-event-city-state').text(ev.City);
							}
							$(newEvent).find('h3').text(ev.EventName);
							if (ev.Venue) {
								$(newEvent).find('.card-event-venue').text(ev.Venue);
							}
							$(el).append(newEvent);
						});
						this.eventListAnalytics();
					} else {
						$(el).html('');
					}
				});
			});
		}
	}

	eventListAnalytics() {
		$('.card.card-event').click((e) => {
			let target = $(e.currentTarget);
			if (target.data('title') != null && target.data('title') !== '') {
				const pkg = {
					full_event_name: target.data('title'),
					event_date: target.data('datedisplay'),
					event: target.data('name'),
					location: `${target.data('city')}, ${target.data('state')}`
				};

				analytics.viewEventDetailsClick(pkg);
			}
		});
	}

	newCookieAddition() {
		if (cookieSwitch) {
			$('#responsiveSurvey-modal').submit((e) => {
				Cookies.set('newsletterForm', true, { expires: expirationDays, sameSite: 'strict' });
				Cookies.set(lightboxId, false, { expires: 0, sameSite: 'strict' });
			});
		}
	}
}

export default Modal;